import { Book, Chapter, Game, Question } from "src/app/models/game";
import { createAction, props } from "@ngrx/store";

export const getGameData = createAction("[GameData] Get Game Data");

export const SuccessGetGameDataAction = createAction(
  "[GameData] - Success Get Game Data",
  props<{ payload: Book[] }>()
);
export const ErrorGameDataAction = createAction(
  "[GameData] - Error",
  props<Error>()
);
export const setGameQuestions = createAction(
  "[Game Data] - Set Questions",
  props<{ payload: Question[] }>()
);
export const setChapterDetails = createAction(
  "[Game Data] - Set Chapter Details",
  props<{ payload: Chapter }>()
);
export const isReviewingWrongAnswers = createAction(
  "[Game Flag] - is Reviewing Wrong Answers"
);

export const notReviewingWrongAnswers = createAction(
  "[Game Flag[] - is NOT Reviewing Wrong Answers"
);
export const isUsingKanji = createAction("[Game Flag] - is Using Kanji");

export const notUsingKanji = createAction("[Game Flag] - is NOT Using Kanji");
export const isUsingSound = createAction("[Game Flag] - is Using Sound");

export const notUsingSound = createAction("[Game Flag] - is NOT Using Sound");

export const playJapaneseToEnglish = createAction(
  "[Game Method] - Japanese to English"
);

export const playEnglishToJapanese = createAction(
  "[Game Method] - English to Japanese"
);
